import {
    DollarSign,
    TrendingUp,
    Users,
    Package,
} from 'lucide-react'

type ConsolidatedMetrics = {
    totalSales: number
    totalProfit: number
    totalCustomers: number
    totalProductsSold: number
}


export function KPICards({ consolidatedMetrics }: { consolidatedMetrics: ConsolidatedMetrics }) {
    return (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
            <div className="rounded-lg border border-slate-200 bg-white p-6">
                <div className="mb-2 flex items-center gap-3">
                    <div className="rounded-lg bg-green-50 p-2">
                        <DollarSign className="h-5 w-5 text-green-600" />
                    </div>
                    <div className='overflow-x-auto'>
                        <p className="text-sm text-slate-600">Ventas Totales</p>
                        <p className="text-2xl font-semibold text-slate-900">{consolidatedMetrics.totalSales.toFixed(2)}</p>
                    </div>
                </div>
            </div>

            <div className="rounded-lg border border-slate-200 bg-white p-6">
                <div className="mb-2 flex items-center gap-3">
                    <div className="rounded-lg bg-primary/10 p-2">
                        <TrendingUp className="h-5 w-5 text-primary" />
                    </div>
                    <div className='overflow-x-auto'>
                        <p className="text-sm text-slate-600">Utilidad Total</p>
                        <p className="text-2xl font-semibold text-slate-900">${consolidatedMetrics.totalProfit.toFixed(2)}</p>
                    </div>
                </div>
            </div>

            <div className="rounded-lg border border-slate-200 bg-white p-6">
                <div className="mb-2 flex items-center gap-3">
                    <div className="rounded-lg bg-purple-50 p-2">
                        <Users className="h-5 w-5 text-purple-600" />
                    </div>
                    <div>
                        <p className="text-sm text-slate-600">Clientes Totales</p>
                        <p className="text-2xl font-semibold text-slate-900">{consolidatedMetrics.totalCustomers}</p>
                    </div>
                </div>
            </div>

            <div className="rounded-lg border border-slate-200 bg-white p-6">
                <div className="mb-2 flex items-center gap-3">
                    <div className="rounded-lg bg-orange-50 p-2">
                        <Package className="h-5 w-5 text-orange-600" />
                    </div>
                    <div className='overflow-x-auto'>
                        <p className="text-sm text-slate-600">Productos Vendidos</p>
                        <p className="text-2xl font-semibold text-slate-900">{consolidatedMetrics.totalProductsSold}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}